<template>
  <div class="field local-url">
    <span v-if="label" class="label text-right" :class="labelClass">
      {{ label }}
    </span>

    <div class="value v-align" :class="valueClass">
      <router-link :to="route" :title="title">
        <div v-html= value></div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    routeName: {
      type: String,
      required: true
    },
    id: Number,
    value: {
      type: String
    },
    label: String,
    title: String,
    width: String
  },

  computed: {
    valueClass: function () {
      if (this.label) {
        return 'col-8'
      }
    },

    labelClass: function () {
      if (this.width === 'large') {
        return 'col-2'
      } else {
        return 'col-4'
      }
    },

    route: function () {
      let route = {
        name: this.routeName
      }

      if (this.id) {
        route.params = {
          id: this.id
        }
      }

      return route
    }
  }
}
</script>
